import { Input, InputWrapperProps } from "@mantine/core";
import { useEffect, useRef, useState } from "react";
import { useFormHelperContext } from "../form";
import { useFormState } from "react-hook-form";
import PhoneInput from "react-phone-input-2";
import 'react-phone-input-2/lib/style.css';
import './phoneNumber.css';
import { InputWrapper } from "../inputWrapper";
export interface FieldInputPhoneNumberProps extends Partial<HTMLInputElement> {
    label: string;
    name: string;
    inputWrapper?: InputWrapperProps;
    withAsterisk?: boolean;
}

const HORIZONTAL_FORM_CLASSES_WRAPPER = {
    label: "flex-grow m-auto pr-4 whitespace-nowrap",
    labelWrapper: "flex-grow",
    root: "flex",
};

export const FieldPhoneNumber: React.FC<FieldInputPhoneNumberProps> = ({ label, name, placeholder, inputWrapper, ...rest }) => {
    const { register, control, formStore, setValue, getValues } = useFormHelperContext();
    const { errors } = useFormState({ control });
    const currentValue = getValues(name)
    const inputRef = useRef<HTMLInputElement | null>(null);
    const isFocused = useRef(false);
    const [valuePlaceholder, setValuePlaceholder] = useState<string>(currentValue);
    if (!register) {
        throw new Error("Field.PhoneNumber must be used within a FormHelper component");
    }

    useEffect(() => {
        if (isFocused.current && inputRef.current) {
            inputRef.current.focus();
        }
    }, [errors]);

    return (
        <InputWrapper label={label} {...inputWrapper} withAsterisk={rest.withAsterisk}>
            <div className="flex flex-col w-full">
                <PhoneInput
                    country={'id'}
                    value={valuePlaceholder}
                    disabled={formStore.readOnly}
                    data-testid={'field-phone-number-' + name}
                    onChange={phone => {
                        setValuePlaceholder(phone);
                        setValue(name, phone);
                    }}
                />
                {typeof errors[name]?.message === 'string' && <Input.Error>{errors[name]?.message}</Input.Error>}
            </div>
        </InputWrapper>

    );
};
